import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ValueBox } from '../../molecules/value-box';
import { useSelector } from '../../store/utils';

export const VersionBox = () => {
  const version = useSelector(({ variables }) => variables.VERSION);

  if (!version) return null;
  if (!('date' in version)) return null;

  return (
    <ValueBox
      title={
        <FormattedMessage
          id="settings.service.version"
          defaultMessage="Verze aplikace"
        />
      }
      value={version.date.replace('T', ' ').replace('Z', '')}
      type="row"
    />
  );
};
